// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".companylogo{flex:0 0 auto;width:144px;height:23px;margin-right:60px}.companylogo path,.companylogo polyline{fill:#0ea795}.header--light:not(.navigation--opened) .companylogo path,.header--light:not(.navigation--opened) .companylogo polyline{fill:#fff}.companylogo--mobile{width:100px;height:16px;margin-right:0}", ""]);
// Exports
module.exports = exports;
